import React, { useState } from 'react';
import './Header.css';
import useAnimatedCounter from '../hooks/useAnimatedCounter';

// Mapeamento de códigos de idioma para emojis de bandeira (versão simples)
const flagEmojis = {
  en: '🇬🇧',
  es: '🇪🇸',
  pt: '🇧🇷'
};

// Mapeamento para os nomes completos dos idiomas
const languageNames = {
  en: 'English',
  es: 'Español',
  pt: 'Português'
};

function Header({ level, coins, userLang, onLanguageChange, onMenuClick }) {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const animatedCoins = useAnimatedCounter(coins);
  const [coinAnimation, setCoinAnimation] = useState('');

  React.useEffect(() => {
    // Se o valor das moedas (real) for diferente do valor animado (display)
    if (coins !== animatedCoins) {
      // Define a classe de animação (gain/spend)
      setCoinAnimation(coins > animatedCoins ? 'coin-gain' : 'coin-spend');
      
      // --- MUDANÇA AQUI: Remove a classe de animação após 300ms (duração da animação no CSS)
      const timer = setTimeout(() => setCoinAnimation(''), 300);
      return () => clearTimeout(timer);
    }
  }, [coins, animatedCoins]);


  const handleLanguageSelect = (lang) => {
    onLanguageChange(lang);
    setIsDropdownOpen(false);
  };

  return (
    <div className="game-header">
      <div className="header-left-items">
        <button className="menu-button" onClick={onMenuClick}>
          ☰
        </button>
        <div className="header-item">
          <span>Lv. {level}</span>
        </div>
      </div>
      
      <div className="header-item coins">
        {/* Aplica a classe apenas durante a animação */}
        <span className={coinAnimation}>{animatedCoins}</span>
        <span className="coin-icon">💰</span>
      </div>
      
      <div className="lang-selector">
        <button className="lang-button" onClick={() => setIsDropdownOpen(!isDropdownOpen)}>
          {flagEmojis[userLang]}
        </button>
        {isDropdownOpen && (
          <div className="lang-dropdown">
            {Object.keys(flagEmojis).map((lang) => (
              <button 
                key={lang} 
                className="lang-option" 
                onClick={() => handleLanguageSelect(lang)}
              >
                {flagEmojis[lang]} {languageNames[lang]}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default Header;